export default __webpack_public_path__ + "static/media/no-activity-found-icon.3d1f2282.png";